import { PriceDetailMapper } from './PriceDetailMapper.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceInsuranceMapper {
  static createModelFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      ...PriceDetailMapper.createModelFromResponse(response),
      baseCoverage: response.base_coverage,
      insured: response.insured,
      maxCoverage: response.max_coverage
    };
  }
}

export { PriceInsuranceMapper };
//# sourceMappingURL=PriceInsuranceMapper.js.map
